const PLANS_ANALYTICS_EVENT = {
  CREATED: 'Plan Created',
  COPIED: 'Plan Copied',
  CREATED_SMART: 'Plan Created Smart',
  WORKOUT_ADDED: 'Plan Workout Added',
  WORKOUT_DELETED: 'Plan Workout Deleted',
  WORKOUT_LOGGED: 'Plan Workout Logged',
  CREATED_FROM_RECOMMENDED: 'Plan Created From Recommended',
  DELETED: 'Plan Deleted',
  WORKOUT_DUPLICATED: 'Plan Workout Duplicated',
  CREATED_FROM_LOG: 'Plan Created From Log',
  STARTED: 'Plan Started'
}

export default PLANS_ANALYTICS_EVENT
